import { useState, useEffect } from 'react';

const API_URL = 'https://bot.devit.es/api';
const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('devit_token')}`
});

export default function Admin() {
  const [stats, setStats] = useState(null);
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('tenants');

  const [blogTema, setBlogTema] = useState('');
  const [blogPalabrasClave, setBlogPalabrasClave] = useState('');
  const [blogGenerando, setBlogGenerando] = useState(false);
  const [borradores, setBorradores] = useState([]);
  const [publicados, setPublicados] = useState([]);
  const [vistaPrevia, setVistaPrevia] = useState(null);

  const [scheduleTema, setScheduleTema] = useState('');
  const [schedulePlataforma, setSchedulePlataforma] = useState('linkedin');
  const [scheduleTono, setScheduleTono] = useState('profesional');
  const [scheduleFecha, setScheduleFecha] = useState('');
  const [scheduleHora, setScheduleHora] = useState('');
  const [scheduleImagen, setScheduleImagen] = useState('');
  const [programaciones, setProgramaciones] = useState([]);
  const [editandoLimite, setEditandoLimite] = useState({});
  const [driveConectado, setDriveConectado] = useState(false);

  // ── Tokens por tenant ────────────────────────────────────────────────────
  const [tokensTenantId, setTokensTenantId] = useState('');
  const [tokensHistorico, setTokensHistorico] = useState(null);
  const [tokensMes,       setTokensMes]       = useState('');
  const [tokensLoading,   setTokensLoading]   = useState(false);

  // ── Academy stats ─────────────────────────────────────────────────────────
  const [academyStats, setAcademyStats] = useState(null);

  // ── Modelos Groq ──────────────────────────────────────────────────────────
  const [modelosData, setModelosData] = useState(null);
  const [modelosLoading, setModelosLoading] = useState(false);

  const load = () => {
    Promise.all([
      fetch(`${API_URL}/admin/stats`, { headers: headers() }).then(r => r.json()),
      fetch(`${API_URL}/admin/tenants`, { headers: headers() }).then(r => r.json()),
    ]).then(([s, t]) => {
      setStats(s);
      setTenants(Array.isArray(t) ? t : []);
      setLoading(false);
    });
  };

  const checkDrive = async () => {
    try {
      const token = localStorage.getItem('devit_token');
      const res = await fetch(`${API_URL}/drive/status?authorization=Bearer%20${token}`);
      const data = await res.json();
      setDriveConectado(data.connected);
    } catch {
      setDriveConectado(false);
    }
  };

  const cargarBorradores = async () => {
    const res = await fetch(`${API_URL}/admin/blog/borradores`, { headers: headers() });
    const data = await res.json();
    setBorradores(data);
  };

  const cargarPublicados = async () => {
    const res = await fetch(`${API_URL}/admin/blog/publicados`, { headers: headers() });
    const data = await res.json();
    setPublicados(data);
  };

  const cargarProgramaciones = async () => {
    const res = await fetch(`${API_URL}/admin/schedule`, { headers: headers() });
    const data = await res.json();
    setProgramaciones(data);
  };

  const toggle = async (id) => {
    await fetch(`${API_URL}/admin/tenants/${id}/toggle`, { method: 'PUT', headers: headers() });
    load();
  };

  const remove = async (id) => {
    if (!window.confirm('¿Eliminar este tenant?')) return;
    await fetch(`${API_URL}/admin/tenants/${id}`, { method: 'DELETE', headers: headers() });
    load();
  };

  // ── NUEVO: toggle módulo social ──────────────────────────────────────────
  const toggleSocial = async (id) => {
    await fetch(`${API_URL}/admin/tenants/${id}/social`, { method: 'PUT', headers: headers() });
    load();
  };

  const guardarLimite = async (id) => {
    const limite = editandoLimite[id];
    if (!limite || isNaN(limite)) return alert('Introduce un número válido');
    const res = await fetch(`${API_URL}/admin/tenants/${id}/limite`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify({ tokens_limite: parseInt(limite) })
    });
    if (res.ok) {
      setEditandoLimite(prev => ({ ...prev, [id]: undefined }));
      load();
    }
  };

  const crearProgramacion = async () => {
    if (!scheduleTema.trim()) return alert('Escribe un tema');
    if (!scheduleFecha || !scheduleHora) return alert('Elige fecha y hora');

    if (schedulePlataforma === 'instagram' && !scheduleImagen.trim()) {
      return alert('Instagram requiere una imagen. Escribe el nombre del archivo en tu carpeta "Devit Media" de Google Drive.');
    }

    const fechaHora = new Date(`${scheduleFecha}T${scheduleHora}`).toISOString();
    const body = {
      tema: scheduleTema,
      plataforma: schedulePlataforma,
      tono: scheduleTono,
      fecha_hora: fechaHora,
    };

    if (scheduleImagen.trim()) {
      body.imagen_nombre = scheduleImagen.trim();
    }

    const res = await fetch(`${API_URL}/admin/schedule`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(body)
    });
    if (res.ok) {
      alert('Publicación programada');
      setScheduleTema('');
      setScheduleImagen('');
      cargarProgramaciones();
    } else {
      const err = await res.json();
      alert('Error: ' + (err.detail || 'desconocido'));
    }
  };

  const eliminarProgramacion = async (id) => {
    if (window.confirm('¿Eliminar esta programación?')) {
      await fetch(`${API_URL}/admin/schedule/${id}`, { method: 'DELETE', headers: headers() });
      cargarProgramaciones();
    }
  };

  const generarBorrador = async () => {
    if (!blogTema.trim()) return alert('Escribe un tema');
    setBlogGenerando(true);
    try {
      const res = await fetch(`${API_URL}/admin/blog/generar`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ tema: blogTema, palabras_clave: blogPalabrasClave, incluir_faqs: true })
      });
      const data = await res.json();
      if (data.exito) {
        setVistaPrevia(data);
        cargarBorradores();
        alert('Borrador generado correctamente');
      } else {
        alert('Error: ' + (data.detail || 'desconocido'));
      }
    } catch {
      alert('Error de conexión');
    }
    setBlogGenerando(false);
  };

  const publicarBorrador = async (postId) => {
    const res = await fetch(`${API_URL}/admin/blog/publicar`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ post_id: postId })
    });
    if (res.ok) {
      alert('Artículo publicado');
      cargarBorradores();
      setVistaPrevia(null);
    } else {
      alert('Error al publicar');
    }
  };

  useEffect(() => { load(); checkDrive(); }, []);

  useEffect(() => {
    if (tab === 'blog') {
      setVistaPrevia(null);
      cargarBorradores();
      cargarPublicados();
      cargarProgramaciones();
    }
    if (tab === 'tokens') {
      setTokensHistorico(null);
      setTokensMes('');
      setTokensTenantId('');
    }
    if (tab === 'academy' && !academyStats) {
      fetch(`${API_URL}/admin/academia/stats`, { headers: headers() })
        .then(r => r.json()).then(setAcademyStats).catch(() => {});
    }
    if (tab === 'modelos' && !modelosData) {
      verificarModelos();
    }
  }, [tab]);

  const verificarModelos = async () => {
    setModelosLoading(true);
    try {
      const res = await fetch(`${API_URL}/admin/modelos/estado`, { headers: headers() });
      const data = await res.json();
      setModelosData(data);
    } catch {}
    setModelosLoading(false);
  };

  const cargarTokensTenant = async (id) => {
    if (!id) return;
    setTokensLoading(true);
    setTokensHistorico(null);
    setTokensMes('');
    try {
      const res = await fetch(`${API_URL}/admin/blog/tokens/tenant/${id}/historico`, { headers: headers() });
      if (!res.ok) { setTokensLoading(false); return; }
      const data = await res.json();
      if (data?.meses?.length) {
        setTokensHistorico(data);
        setTokensMes(data.meses[0]); // mes más reciente por defecto
      }
    } catch {}
    setTokensLoading(false);
  };

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Panel Admin</div>
          <div className="page-sub">Gestión de clientes y blog</div>
        </div>
      </div>

      <div className="tab-row" style={{ marginBottom: '20px' }}>
        <div className={`tab ${tab === 'tenants' ? 'active' : ''}`} onClick={() => setTab('tenants')}>Clientes</div>
        <div className={`tab ${tab === 'blog' ? 'active' : ''}`} onClick={() => setTab('blog')}>Blog SEO</div>
        <div className={`tab ${tab === 'tokens' ? 'active' : ''}`} onClick={() => setTab('tokens')}>◈ Tokens</div>
        <div className={`tab ${tab === 'academy' ? 'active' : ''}`} onClick={() => setTab('academy')}>🎓 Academy</div>
        <div className={`tab ${tab === 'modelos' ? 'active' : ''}`} onClick={() => setTab('modelos')}>⚡ Modelos</div>
      </div>

      {tab === 'tenants' && (
        <>
          <div className="metrics" style={{marginBottom:'20px'}}>
            <div className="metric metric-green">
              <div className="metric-label">Total clientes</div>
              <div className="metric-value">{stats?.total_tenants || 0}</div>
            </div>
            <div className="metric metric-cyan">
              <div className="metric-label">Activos</div>
              <div className="metric-value">{stats?.activos || 0}</div>
            </div>
            <div className="metric">
              <div className="metric-label">Con Stripe</div>
              <div className="metric-value">{stats?.con_stripe || 0}</div>
            </div>
            <div className="metric metric-amber">
              <div className="metric-label">Tokens mes</div>
              <div className="metric-value">{Math.round((stats?.tokens_mes || 0)/1000)}k</div>
            </div>
          </div>

          <div className="card" style={{marginBottom:'16px'}}>
            <div className="card-title">Distribución por plan</div>
            <div style={{display:'flex', gap:'8px', flexWrap:'wrap', marginTop:'4px'}}>
              {stats?.por_plan?.map(p => (
                <span key={p.plan} className="badge badge-cyan">{p.plan}: {p.total}</span>
              ))}
            </div>
          </div>

          <div className="card">
            <div className="card-title">Clientes</div>
            <table className="tenants-table">
              <thead>
                <tr>
                  <th>Empresa</th><th>Email</th><th>Plan</th><th>Especialidad</th>
                  <th>WhatsApp</th><th>Calendar</th><th>Estado</th>
                  <th>Social</th>{/* ── NUEVO */}
                  <th>Acciones</th><th>Límite tokens</th>
                </tr>
              </thead>
              <tbody>
                {tenants.map(t => (
                  <tr key={t.id}>
                    <td style={{color:'var(--text)'}}>{t.nombre}</td>
                    <td>{t.email}</td>
                    <td><span className="badge badge-cyan">{t.plan}</span></td>
                    <td>{t.especialidad || '—'}</td>
                    <td>{t.whatsapp ? <span className="badge badge-green">✓</span> : <span className="badge badge-red">✗</span>}</td>
                    <td>{t.google_calendar ? <span className="badge badge-green">✓</span> : <span className="badge badge-red">✗</span>}</td>
                    <td><span className={`badge ${t.activo ? 'badge-green' : 'badge-red'}`}>{t.activo ? 'activo' : 'inactivo'}</span></td>
                    {/* ── NUEVO: columna módulo social ── */}
                    <td>
                      <button
                        onClick={() => toggleSocial(t.id)}
                        title={t.modulo_social ? 'Desactivar módulo social' : 'Activar módulo social'}
                        style={{
                          background:   t.modulo_social ? '#1a3a2a' : '#2a2e4a',
                          border:       `1px solid ${t.modulo_social ? '#2a5a3a' : '#3a3e5a'}`,
                          color:        t.modulo_social ? '#4ade80' : '#5a5e82',
                          borderRadius: 6,
                          padding:      '3px 10px',
                          cursor:       'pointer',
                          fontSize:     11,
                          fontWeight:   600,
                        }}
                      >
                        {t.modulo_social ? '📣 ON' : '📣 OFF'}
                      </button>
                    </td>
                    <td>
                      <div style={{display:'flex', gap:'6px'}}>
                        <button className="btn btn-ghost" style={{fontSize:'10px', padding:'3px 8px'}} onClick={() => toggle(t.id)}>
                          {t.activo ? 'Pausar' : 'Activar'}
                        </button>
                        <button className="btn btn-danger" style={{fontSize:'10px', padding:'3px 8px'}} onClick={() => remove(t.id)}>
                          Borrar
                        </button>
                      </div>
                    </td>
                    <td>
                      <div style={{display:'flex', gap:'4px', alignItems:'center'}}>
                        <input type="number"
                          style={{width:'90px', fontSize:'11px', padding:'3px 6px', background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:'4px', color:'var(--text)'}}
                          value={editandoLimite[t.id] !== undefined ? editandoLimite[t.id] : (t.tokens_limite || 5000000)}
                          onChange={e => setEditandoLimite(prev => ({...prev, [t.id]: e.target.value}))}
                        />
                        {editandoLimite[t.id] !== undefined && (
                          <button className="btn btn-ghost" style={{fontSize:'10px', padding:'3px 6px'}} onClick={() => guardarLimite(t.id)}>✓</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {tab === 'tokens' && (
        <div className="content">
          <div className="card" style={{ marginBottom: '20px' }}>
            <div className="card-title" style={{ marginBottom: '12px' }}>Selecciona un cliente</div>
            <select
              className="form-input"
              style={{ maxWidth: '380px' }}
              value={tokensTenantId}
              onChange={e => { setTokensTenantId(e.target.value); cargarTokensTenant(e.target.value); }}
            >
              <option value=''>— Elige un tenant —</option>
              {tenants.map(t => (
                <option key={t.id} value={t.id}>
                  {t.nombre || t.email} ({t.plan})
                </option>
              ))}
            </select>
          </div>

          {tokensLoading && (
            <div style={{ color: 'var(--text3)', padding: '20px' }}>Cargando...</div>
          )}

          {tokensHistorico && !tokensLoading && (() => {
            const tenant  = tenants.find(t => t.id === tokensTenantId);
            const detalle = tokensHistorico.por_mes[tokensMes];
            if (!detalle) return null;
            const fmtK    = n => n >= 1000 ? `${Math.round(n/1000)}k` : String(n);
            const fmtMes  = m => { const [y, mo] = m.split('-'); return `${['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'][parseInt(mo)-1]} ${y}`; };
            const maxCanal = Math.max(...detalle.canales.map(c => c.tokens), 1);
            const maxCont  = Math.max(...detalle.contenido.map(c => c.tokens), 1);
            return (
              <>
                {/* Selector de mes */}
                <div className="card" style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: '13px', color: 'var(--text2)', fontWeight: 600 }}>Mes:</span>
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                    {tokensHistorico.meses.map(m => (
                      <button
                        key={m}
                        onClick={() => setTokensMes(m)}
                        style={{
                          padding: '5px 12px', borderRadius: '6px', fontSize: '12px',
                          fontWeight: 600, cursor: 'pointer',
                          background: m === tokensMes ? 'var(--purple)' : 'var(--bg3)',
                          color:      m === tokensMes ? '#fff' : 'var(--text2)',
                          border:     m === tokensMes ? '1px solid var(--purple)' : '1px solid var(--border)',
                        }}
                      >{fmtMes(m)}</button>
                    ))}
                  </div>
                  {tenant && <span className="badge badge-cyan" style={{ marginLeft: 'auto' }}>{tenant.plan}</span>}
                </div>

                {/* Métricas globales */}
                <div className="metrics" style={{ marginBottom: '20px' }}>
                  <div className="metric metric-cyan">
                    <div className="metric-label">Total {fmtMes(tokensMes)}</div>
                    <div className="metric-value">{fmtK(detalle.total_global)}</div>
                  </div>
                  <div className="metric">
                    <div className="metric-label">Chats</div>
                    <div className="metric-value">{fmtK(detalle.total_chats)}</div>
                  </div>
                  <div className="metric metric-green">
                    <div className="metric-label">Contenido</div>
                    <div className="metric-value">{fmtK(detalle.total_contenido)}</div>
                  </div>
                  <div className="metric">
                    <div className="metric-label">Meses con datos</div>
                    <div className="metric-value">{tokensHistorico.meses.length}</div>
                  </div>
                </div>

                {/* Canales de chat */}
                <div className="card" style={{ marginBottom: '16px' }}>
                  <div className="card-title" style={{ marginBottom: '14px' }}>Canales de chat</div>
                  {detalle.canales.map(c => (
                    <div key={c.source} style={{ marginBottom: '12px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '4px' }}>
                        <span style={{ color: 'var(--text)' }}>{c.icono} {c.label}</span>
                        <span style={{ color: 'var(--cyan)', fontWeight: 600 }}>{fmtK(c.tokens)}</span>
                      </div>
                      <div style={{ background: 'var(--bg3)', borderRadius: '4px', height: '6px' }}>
                        <div style={{ width: `${Math.round((c.tokens / maxCanal) * 100)}%`, background: 'var(--cyan)', height: '6px', borderRadius: '4px', transition: 'width .3s' }} />
                      </div>
                    </div>
                  ))}
                </div>

                {/* Contenido generado */}
                <div className="card">
                  <div className="card-title" style={{ marginBottom: '14px' }}>Contenido generado</div>
                  {detalle.contenido.map(c => (
                    <div key={c.source} style={{ marginBottom: '12px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '4px' }}>
                        <span style={{ color: 'var(--text)' }}>{c.icono} {c.label}</span>
                        <span style={{ color: 'var(--green)', fontWeight: 600 }}>{fmtK(c.tokens)}</span>
                      </div>
                      <div style={{ background: 'var(--bg3)', borderRadius: '4px', height: '6px' }}>
                        <div style={{ width: `${Math.round((c.tokens / maxCont) * 100)}%`, background: 'var(--green)', height: '6px', borderRadius: '4px', transition: 'width .3s' }} />
                      </div>
                    </div>
                  ))}
                </div>
              </>
            );
          })()}
        </div>
      )}

      {tab === 'blog' && (
        <div className="content">

          <div className="card" style={{marginBottom:'16px', padding:'12px 16px'}}>
            <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
              <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                <span style={{fontSize:'20px'}}>📁</span>
                <div>
                  <div style={{fontSize:'13px', color:'var(--text)', fontWeight:600}}>Google Drive — Devit Media</div>
                  <div style={{fontSize:'11px', color:'var(--text3)', marginTop:'2px'}}>
                    {driveConectado
                      ? 'Conectado — sube tus imágenes a la carpeta "Devit Media" en tu Drive'
                      : 'No conectado — necesario para publicar con imágenes en redes sociales'}
                  </div>
                </div>
              </div>
              {driveConectado ? (
                <button className="btn btn-danger" style={{fontSize:'11px', padding:'5px 12px'}}
                  onClick={async () => {
                    const token = localStorage.getItem('devit_token');
                    await fetch(`${API_URL}/drive/disconnect?authorization=Bearer%20${token}`, { method: 'DELETE' });
                    setDriveConectado(false);
                  }}>
                  Desconectar
                </button>
              ) : (
                <button className="btn btn-ghost" style={{fontSize:'11px', padding:'5px 12px'}}
                  onClick={async () => {
                    const token = localStorage.getItem('devit_token');
                    const res = await fetch(`${API_URL}/drive/connect?authorization=Bearer%20${token}`);
                    const data = await res.json();
                    if (data.auth_url) window.location.href = data.auth_url;
                  }}>
                  Conectar Drive
                </button>
              )}
            </div>
          </div>

          <div className="card" style={{marginBottom:'20px'}}>
            <div className="card-title">Generar nuevo artículo (SEO/GEO)</div>
            <div className="form-group">
              <label className="form-label">Tema principal</label>
              <input className="form-input" placeholder="Ej: Cómo los agentes IA mejoran la productividad en pymes"
                value={blogTema} onChange={e => setBlogTema(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Palabras clave (opcional, separadas por comas)</label>
              <input className="form-input" placeholder="ia, automatización, productividad"
                value={blogPalabrasClave} onChange={e => setBlogPalabrasClave(e.target.value)} />
            </div>
            <button className="btn btn-primary" onClick={generarBorrador} disabled={blogGenerando}>
              {blogGenerando ? 'Generando...' : 'Generar borrador'}
            </button>
          </div>

          <div className="card" style={{marginTop:'20px'}}>
            <div className="card-title">Artículos publicados</div>
            {publicados.length === 0 && <div>No hay artículos publicados.</div>}
            {publicados.map(p => (
              <div key={p.id} style={{marginBottom:'12px', borderBottom:'1px solid var(--border)', padding:'8px 0'}}>
                <div><strong>{p.titulo}</strong> (publicado: {new Date(p.publicado_en).toLocaleString()})</div>
                <div style={{marginTop:'6px'}}>
                  <a href={`/blog/${p.slug}`} target="_blank" rel="noreferrer" className="btn btn-ghost" style={{fontSize:'12px', marginRight:'8px'}}>Ver</a>
                  <button className="btn btn-danger" style={{fontSize:'12px'}} onClick={async () => {
                    if (window.confirm('¿Eliminar este artículo permanentemente?')) {
                      await fetch(`${API_URL}/admin/blog/posts/${p.id}`, { method: 'DELETE', headers: headers() });
                      cargarPublicados();
                      cargarBorradores();
                    }
                  }}>Eliminar</button>
                </div>
              </div>
            ))}
          </div>

          <div className="card" style={{marginTop:'20px'}}>
            <div className="card-title">Programar nueva publicación</div>
            <div className="form-group">
              <label className="form-label">Tema</label>
              <input className="form-input" placeholder="Ej: Beneficios de la IA en RRHH"
                value={scheduleTema} onChange={e => setScheduleTema(e.target.value)} />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Plataforma</label>
                <select className="form-input" value={schedulePlataforma} onChange={e => { setSchedulePlataforma(e.target.value); setScheduleImagen(''); }}>
                  <option value="linkedin">LinkedIn</option>
                  <option value="facebook">Facebook</option>
                  <option value="instagram">Instagram</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Tono</label>
                <select className="form-input" value={scheduleTono} onChange={e => setScheduleTono(e.target.value)}>
                  <option value="profesional">Profesional</option>
                  <option value="inspirador">Inspirador</option>
                  <option value="educativo">Educativo</option>
                  <option value="provocador">Provocador</option>
                  <option value="casual">Casual</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                Imagen desde Google Drive
                {schedulePlataforma === 'instagram' && (
                  <span style={{color:'var(--amber)', marginLeft:'6px', fontSize:'10px'}}>⚠ Obligatorio para Instagram</span>
                )}
                {schedulePlataforma !== 'instagram' && (
                  <span style={{color:'var(--text3)', marginLeft:'6px', fontSize:'10px'}}>Opcional para LinkedIn y Facebook</span>
                )}
              </label>
              <input
                className="form-input"
                placeholder='Nombre del archivo en carpeta "Devit Media" — ej: foto_producto.jpg'
                value={scheduleImagen}
                onChange={e => setScheduleImagen(e.target.value)}
                style={{borderColor: schedulePlataforma === 'instagram' && !scheduleImagen ? 'var(--amber)' : undefined}}
              />
              {!driveConectado && (
                <div style={{fontSize:'11px', color:'var(--amber)', marginTop:'4px'}}>
                  ⚠ Conecta Google Drive para publicar con imágenes
                </div>
              )}
              {driveConectado && (
                <div style={{fontSize:'11px', color:'var(--text3)', marginTop:'4px'}}>
                  📁 El archivo debe estar en la carpeta "Devit Media" de tu Google Drive
                </div>
              )}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Fecha</label>
                <input type="date" className="form-input" value={scheduleFecha} onChange={e => setScheduleFecha(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Hora (hora de Madrid)</label>
                <input type="time" step="60" className="form-input" value={scheduleHora} onChange={e => setScheduleHora(e.target.value)} />
              </div>
            </div>
            <button className="btn btn-primary" onClick={crearProgramacion}>Programar publicación</button>
          </div>

          <div className="card" style={{marginTop:'20px'}}>
            <div className="card-title">Publicaciones programadas</div>
            {programaciones.length === 0 && <div>No hay publicaciones programadas.</div>}
            {programaciones.map(p => (
              <div key={p.id} style={{marginBottom:'12px', borderBottom:'1px solid var(--border)', padding:'8px 0'}}>
                <div><strong>{p.tema}</strong> — {p.plataforma}</div>
                {p.imagen_nombre && (
                  <div style={{fontSize:'11px', color:'var(--text3)', marginTop:'2px'}}>
                    📸 Imagen: {p.imagen_nombre}
                  </div>
                )}
                <div>Programada para: {(() => {
                  if (!p.fecha_hora) return 'Fecha no disponible';
                  const fecha = typeof p.fecha_hora === 'number' ? new Date(p.fecha_hora) : new Date(p.fecha_hora);
                  return isNaN(fecha) ? 'Fecha inválida' : fecha.toLocaleString('es-ES', { timeZone: 'Europe/Madrid', hour12: false });
                })()}</div>
                <div>Estado: {p.publicado ? '✅ Publicada' : '⏳ Pendiente'}</div>
                {!p.publicado && (
                  <button className="btn btn-danger" style={{fontSize:'12px', marginTop:'6px'}} onClick={() => eliminarProgramacion(p.id)}>
                    Cancelar
                  </button>
                )}
              </div>
            ))}
          </div>

          {vistaPrevia && vistaPrevia.contenido_html && (
            <div className="card" style={{marginBottom:'20px'}}>
              <div className="card-title">Vista previa del borrador</div>
              <div><strong>Título:</strong> {vistaPrevia.titulo}</div>
              <div><strong>Meta descripción:</strong> {vistaPrevia.meta_descripcion}</div>
              <div><strong>Slug:</strong> {vistaPrevia.slug}</div>
              <div dangerouslySetInnerHTML={{ __html: vistaPrevia.contenido_html }} />
              {vistaPrevia.faqs && (
                <div>
                  <strong>FAQs:</strong>
                  {vistaPrevia.faqs.map((faq, i) => (
                    <div key={i}><b>{faq.pregunta}</b> {faq.respuesta}</div>
                  ))}
                </div>
              )}
              <button className="btn btn-success" style={{marginTop:'10px'}} onClick={() => publicarBorrador(vistaPrevia.post_id)}>
                Publicar ahora
              </button>
            </div>
          )}

          <div className="card">
            <div className="card-title">Borradores guardados</div>
            {borradores.length === 0 && <div>No hay borradores.</div>}
            {borradores.map(b => (
              <div key={b.id} style={{marginBottom:'12px', borderBottom:'1px solid var(--border)', padding:'8px 0'}}>
                <div><strong>{b.titulo}</strong> (creado: {new Date(b.creado_en).toLocaleString()})</div>
                <div style={{marginTop:'6px'}}>
                  <button className="btn btn-success" style={{fontSize:'12px', marginRight:'8px'}} onClick={() => publicarBorrador(b.id)}>Publicar</button>
                  <button className="btn btn-danger" style={{fontSize:'12px'}} onClick={async () => {
                    await fetch(`${API_URL}/admin/blog/borradores/${b.id}`, { method: 'DELETE', headers: headers() });
                    cargarBorradores();
                  }}>Eliminar</button>
                </div>
              </div>
            ))}
          </div>

        </div>
      )}

      {tab === 'academy' && (
        <div>
          {!academyStats ? (
            <div style={{color:'#9b9fc4'}}>Cargando estadísticas...</div>
          ) : (
            <>
              <div className="metrics" style={{marginBottom:'20px'}}>
                <div className="metric">
                  <div className="metric-label">Visitas landing</div>
                  <div className="metric-value">{academyStats.visitas_landing}</div>
                </div>
                <div className="metric metric-green">
                  <div className="metric-label">Registros</div>
                  <div className="metric-value">{academyStats.registros}</div>
                </div>
                <div className="metric metric-cyan">
                  <div className="metric-label">Iniciaron curso</div>
                  <div className="metric-value">{academyStats.usuarios_con_progreso}</div>
                </div>
                <div className="metric metric-green">
                  <div className="metric-label">Aprobaron quiz</div>
                  <div className="metric-value">{academyStats.aprobados}</div>
                </div>
                <div className="metric">
                  <div className="metric-label">Diplomas emitidos</div>
                  <div className="metric-value">{academyStats.diplomas}</div>
                </div>
                <div className="metric metric-cyan">
                  <div className="metric-label">Descargas PDF</div>
                  <div className="metric-value">{academyStats.descargas_pdf}</div>
                </div>
              </div>

              <div className="card" style={{marginBottom:'16px'}}>
                <div className="card-title">Embudo de conversión</div>
                {[
                  { label: 'Visitaron la landing', value: academyStats.visitas_landing },
                  { label: 'Se registraron', value: academyStats.registros },
                  { label: 'Iniciaron el curso', value: academyStats.usuarios_con_progreso },
                  { label: 'Intentaron el quiz', value: academyStats.intentos_quiz },
                  { label: 'Aprobaron (≥80%)', value: academyStats.aprobados },
                  { label: 'Descargaron diploma', value: academyStats.descargas_pdf },
                ].map((row, i) => {
                  const base = academyStats.visitas_landing > 0 ? academyStats.visitas_landing : 1;
                  const pct = Math.round(row.value / base * 100);
                  return (
                    <div key={i} style={{marginBottom:'12px'}}>
                      <div style={{display:'flex', justifyContent:'space-between', fontSize:'13px', marginBottom:'4px'}}>
                        <span style={{color:'#c0c4e0'}}>{row.label}</span>
                        <span style={{color:'#f0f0ff', fontWeight:600}}>
                          {row.value} <span style={{color:'#5a5e82', fontWeight:400, fontSize:'11px'}}>({pct}%)</span>
                        </span>
                      </div>
                      <div style={{background:'#1a1c2e', borderRadius:'4px', height:'6px'}}>
                        <div style={{background:'#7c4dff', borderRadius:'4px', height:'6px', width:`${Math.min(pct,100)}%`, transition:'width 0.3s'}} />
                      </div>
                    </div>
                  );
                })}
                <div style={{marginTop:'8px', fontSize:'12px', color:'#5a5e82'}}>
                  Tasa de aprobación del quiz: <strong style={{color:'#16a34a'}}>{academyStats.tasa_aprobacion}%</strong>
                </div>
              </div>

              <div className="card">
                <div className="card-title">Últimos 15 registros</div>
                <table style={{width:'100%', fontSize:'12px', borderCollapse:'collapse'}}>
                  <thead>
                    <tr style={{color:'#5a5e82', borderBottom:'1px solid var(--border)'}}>
                      <th style={{textAlign:'left', padding:'6px 8px', fontWeight:500}}>Nombre</th>
                      <th style={{textAlign:'left', padding:'6px 8px', fontWeight:500}}>Email</th>
                      <th style={{textAlign:'left', padding:'6px 8px', fontWeight:500}}>Fecha</th>
                      <th style={{textAlign:'center', padding:'6px 8px', fontWeight:500}}>Diploma</th>
                    </tr>
                  </thead>
                  <tbody>
                    {academyStats.ultimos_registros.map((r, i) => (
                      <tr key={i} style={{borderBottom:'1px solid #1a1c2e'}}>
                        <td style={{padding:'7px 8px', color:'#f0f0ff'}}>{r.nombre}</td>
                        <td style={{padding:'7px 8px', color:'#9b9fc4'}}>{r.email}</td>
                        <td style={{padding:'7px 8px', color:'#5a5e82', whiteSpace:'nowrap'}}>{r.fecha}</td>
                        <td style={{padding:'7px 8px', textAlign:'center'}}>
                          {r.tiene_diploma
                            ? <a href={`/api/academia/certificado/${r.diploma_codigo}/pdf`} target="_blank" rel="noreferrer" style={{color:'#16a34a', textDecoration:'none', fontWeight:600}}>✓ PDF</a>
                            : <span style={{color:'#3a3a4a'}}>—</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}

      {tab === 'modelos' && (
        <div>
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'20px'}}>
            <div>
              <div style={{fontSize:'15px', fontWeight:600, color:'#f0f0ff'}}>Monitor de modelos Groq</div>
              <div style={{fontSize:'12px', color:'#5a5e82', marginTop:'2px'}}>
                {modelosData ? `Última verificación: ${modelosData.verificado_en}` : 'Sin verificar'}
              </div>
            </div>
            <button className="btn" onClick={verificarModelos} disabled={modelosLoading}
              style={{fontSize:'13px'}}>
              {modelosLoading ? 'Verificando...' : '🔄 Verificar ahora'}
            </button>
          </div>

          {modelosData?.error && (
            <div style={{background:'#2a1a1a', border:'1px solid #7c2020', borderRadius:'8px', padding:'12px 16px', marginBottom:'16px', color:'#ff6b6b', fontSize:'13px'}}>
              ⚠ Error al contactar con Groq API: {modelosData.error}
            </div>
          )}

          {modelosData && (
            <>
              <div className="card" style={{marginBottom:'16px'}}>
                <div className="card-title">Modelos en producción</div>
                {modelosData.en_uso.map((m, i) => (
                  <div key={i} style={{
                    display:'flex', alignItems:'flex-start', gap:'12px',
                    padding:'12px 0', borderBottom: i < modelosData.en_uso.length - 1 ? '1px solid #1a1c2e' : 'none'
                  }}>
                    <div style={{
                      width:'10px', height:'10px', borderRadius:'50%', marginTop:'4px', flexShrink:0,
                      background: m.activo === true ? '#16a34a' : m.activo === false ? '#dc2626' : '#5a5e82',
                      boxShadow: m.activo === true ? '0 0 6px #16a34a' : m.activo === false ? '0 0 6px #dc2626' : 'none',
                    }} />
                    <div style={{flex:1}}>
                      <div style={{display:'flex', alignItems:'center', gap:'10px', marginBottom:'4px'}}>
                        <code style={{color:'#c0c4e0', fontSize:'13px', fontWeight:600}}>{m.id}</code>
                        <span style={{
                          fontSize:'11px', fontWeight:600, padding:'2px 7px', borderRadius:'4px',
                          background: m.activo === true ? '#0a2a14' : m.activo === false ? '#2a1010' : '#1a1c2e',
                          color: m.activo === true ? '#16a34a' : m.activo === false ? '#dc2626' : '#5a5e82',
                        }}>
                          {m.activo === true ? '✓ Activo' : m.activo === false ? '✗ DEPRECADO' : '? Sin datos'}
                        </span>
                      </div>
                      <div style={{fontSize:'12px', color:'#5a5e82'}}>
                        Usado en: {m.uso.join(' · ')}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="card">
                <div className="card-title">
                  Todos los modelos disponibles en Groq
                  <span style={{marginLeft:'8px', fontSize:'12px', fontWeight:400, color:'#5a5e82'}}>
                    ({modelosData.disponibles.length} modelos)
                  </span>
                </div>
                <div style={{display:'flex', flexWrap:'wrap', gap:'6px', marginTop:'4px'}}>
                  {modelosData.disponibles.map((id, i) => {
                    const enUso = modelosData.en_uso.some(m => m.id === id);
                    return (
                      <span key={i} style={{
                        fontSize:'11px', padding:'3px 8px', borderRadius:'4px',
                        background: enUso ? '#16132a' : '#12141f',
                        border: `1px solid ${enUso ? '#7c4dff' : '#1e2035'}`,
                        color: enUso ? '#c0a8ff' : '#5a5e82',
                        fontFamily:'monospace',
                      }}>
                        {id}
                        {enUso && <span style={{marginLeft:'4px', color:'#7c4dff'}}>●</span>}
                      </span>
                    );
                  })}
                </div>
              </div>
            </>
          )}

          {!modelosData && !modelosLoading && (
            <div style={{color:'#5a5e82', fontSize:'13px'}}>Pulsa "Verificar ahora" para consultar el estado de los modelos.</div>
          )}
        </div>
      )}
    </div>
  );
}